import { AangevraagdeLandelijkeFaciliteiten } from "@/entities/vestiging";
import { LandelijkeFaciliteitenHeader } from "@/features/faciliteiten/components/shared/landelijk/landelijke-faciliteiten-header.tsx";
import { Separator } from "@/shared/components";
import { LandelijkeFaciliteitenRow } from "./landelijke-faciliteiten-row";

type LandelijkeFaciliteitenReadOnlyProps = {
    aanvraag: AangevraagdeLandelijkeFaciliteiten | null;
};

export function LandelijkeFaciliteitenReadOnly({ aanvraag }: LandelijkeFaciliteitenReadOnlyProps) {
    return (
        <div className="grid gap-6 pt-4">
            <LandelijkeFaciliteitenHeader readOnly />
            <Separator orientation="horizontal" />
            <LandelijkeFaciliteitenRow status={aanvraag?.status} toelichting={aanvraag?.toelichting} />
        </div>
    );
}
